import { Container, Graphics, Sprite } from 'pixi.js';

class Layer extends Container {
	layer = null;
	layerGraphics = null;
	constructor() {
		super();
		this.interactiveChildren = false;
		this.cacheAsBitmap = true;

		this.layer = new Sprite();
		this.addChild(this.layer);

		this.layerGraphics = new Graphics();
		this.layer.addChild(this.layerGraphics);
	}
	resize() {
		this.cacheAsBitmap = false;
		this.layerGraphics.clear();
		this.layerGraphics.beginFill(0x000);
		this.layerGraphics.drawRect(
			0,
			0,
			window.CurrentSize.w,
			window.CurrentSize.h
		);
		this.layerGraphics.endFill();
		this.layerGraphics.alpha = 0.35;

		this.cacheAsBitmap = true;
	}
}

export default Layer;
